/**
 * Display titles for pins: never show a raw source URL as the card title.
 */

export function looksLikeUrl(value) {
  const text = String(value || '').trim();
  if (!text) return false;
  if (/^https?:\/\//i.test(text)) return true;
  if (/^www\./i.test(text)) return true;
  try {
    const parsed = new URL(text.includes('://') ? text : `https://${text}`);
    if (!parsed.hostname || !parsed.hostname.includes('.')) return false;
    // Hostname-only or path-less strings that look like domains
    return /[a-z0-9-]+\.[a-z]{2,}/i.test(parsed.hostname);
  } catch {
    return false;
  }
}

export function titleFromUrl(url) {
  try {
    const parsed = new URL(url);
    const host = (parsed.hostname || '').replace(/^www\./i, '');
    const segments = (parsed.pathname || '')
      .split('/')
      .map(part => {
        try {
          return decodeURIComponent(part);
        } catch {
          return part;
        }
      })
      .filter(Boolean)
      .filter(part => !/^\d+$/.test(part));

    if (segments.length) {
      const last = segments[segments.length - 1]
        .replace(/\.\w{2,5}$/, '')
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (last.length >= 3 && last.length <= 80 && !looksLikeUrl(last)) {
        return last.replace(/\b\w/g, char => char.toUpperCase());
      }
    }

    return host || 'Web page';
  } catch {
    return 'Web page';
  }
}

/**
 * Pick a human-readable title. Skips URL-like candidates.
 * @param {string} title
 * @param {string} [url]
 * @param {{ snippet?: string, fallback?: string }} [extras]
 */
export function resolveDisplayTitle(title, url, extras = {}) {
  const candidates = [title, extras.snippet, extras.fallback]
    .map(value => String(value || '').trim())
    .filter(Boolean);

  for (const candidate of candidates) {
    if (!looksLikeUrl(candidate)) return candidate.slice(0, 200);
  }

  if (url) return titleFromUrl(url).slice(0, 200);
  return String(extras.fallback || 'Untitled').slice(0, 200);
}
